import Utils from "../Shared/Utils";
import ThirdGamesListUI from "./ThirdGamesListUI";
import GameList from "../Models/GameList";
import AudioManager from "../Shared/AudioManager";
import { Global } from "../Shared/Global";
import NetworkLogic from "../Shared/NetworkLogic";
import ImageCache from "../Shared/ImageCache";
import UIManager from "../Shared/UIManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class TopElectronicUI extends cc.Component {
    @property(cc.Prefab)
    pfbThirdGamesListUI: cc.Prefab = null

    @property(cc.Node)
    nodeNoData: cc.Node = null

    @property(cc.Node)
    nodeTemplateItem: cc.Node = null

    @property(cc.Layout)
    lyContent: cc.Layout = null

    @property(cc.Node)
    nodeMore: cc.Node = null

    @property(cc.Node)
    nodeQipai: cc.Node = null

    @property(cc.Node)
    nodeDianzi: cc.Node = null

    @property(cc.Node)
    nodeBuyu: cc.Node = null

    @property(cc.Node)
    nodeLeft: cc.Node = null

    @property(cc.Node)
    nodeRight: cc.Node = null

    @property(cc.Integer)
    gameType: Global.GameType = Global.GameType.Default

    private _topGames = []
    private _electronicID = -1

    onLoad () {
        this.nodeTemplateItem.parent = null
        this.nodeLeft.active = false
        this.nodeRight.active = false
        this.nodeNoData.active = false
    }

    start () {
        Utils.hideGameNode()

        for (let i = 0; i < GameList.serverData["tabList"].length; i++) {
            const cfg = GameList.serverData["tabList"][i];
            if (cfg["gameTypes"] === this.gameType.toString()) {
                this._electronicID = cfg["id"]
                break
            }
        }

        if (this.gameType === Global.GameType.Fish) {
            this.nodeMore.active = false
        }

        this.nodeDianzi.active = false
        this.nodeQipai.active = false
        this.nodeBuyu.active = false
        
        if (this.gameType === Global.GameType.Electronic) {
            this.nodeDianzi.active = true
        }else if (this.gameType === Global.GameType.Chess) {
            this.nodeQipai.active = true
        }else if (this.gameType === Global.GameType.Fish) {
            this.nodeBuyu.active = true
        }

        UIManager.showLoadingUI()
        NetworkLogic.hotPlusGames(this.gameType, function (data) {
            UIManager.hideLoadingUI()
            this._topGames = data
            this.nodeNoData.active = this._topGames.length === 0
            this.createItems()
            this.lyContent.updateLayout()
            this.checkLeftAndRightBtn()
        }.bind(this))
    }

    onDestroy () {
        this.nodeTemplateItem.destroy()
    }

    onBtnClick (event, userData) {
        if (userData === "home") {
            AudioManager.playSound("close")
            this.node.destroy()
            Utils.showGameNode()
        }else if (userData === "more") {
            AudioManager.playSound("show")
            let thirdGamesListUI = cc.instantiate(this.pfbThirdGamesListUI).getComponent(ThirdGamesListUI)
            thirdGamesListUI.toggleContainer.isSelectFirstItem = true
            thirdGamesListUI.gameTypeID = this._electronicID
            thirdGamesListUI.node.parent = this.node.parent
            this.node.destroy()
        }
    }

    onScrollViewEvent (scrollView, eventType: cc.ScrollView.EventType) {
        if (eventType === cc.ScrollView.EventType.SCROLLING) {
            this.checkLeftAndRightBtn()
        }
    }

    private createItems () {
        for (let i = 0; i < this._topGames.length; i++) {
            let node = cc.instantiate(this.nodeTemplateItem)
            let cfg = this._topGames[i]
            let clickEventHandler = new cc.Component.EventHandler()
            node.parent = this.lyContent.node
            clickEventHandler.target = cc.find("Canvas/gameNode")
            clickEventHandler.component = "HallUI"
            clickEventHandler.handler = "onGameItemClick"
            cc.find("node/play_new", node)["gameConfig"] = cfg
            cc.find("node/play_new", node).getComponent(cc.Button).clickEvents.push(clickEventHandler)
            cc.find("node/itemBg/name", node).getComponent(cc.Label).string = cfg.gameTitleCn
            cc.find("node/rank" + (i + 1), node) && (cc.find("node/rank" + (i + 1), node).active = true)

            if (i > 2) {
                let nodeRank = cc.find("node/iconRank", node)
                let lbRank = nodeRank.getChildByName("rank").getComponent(cc.Label)
                nodeRank.active = true
                lbRank.string = (i + 1).toString()
            }

            if (cfg.gameStatus && cfg.gameStatus !== "0") {
                cc.find("node/mask/icon", node).color = cc.color(70, 70, 70)
                cc.find("node/mask/maintenance", node).active = true
            }

            ImageCache.loadImage(GameList.serverData["imgPrefix"] + cfg.gameImageUrl1, function (err, texture) {
                if (!err && node && node.isValid) {
                    cc.find("node/mask/icon", node).getComponent(cc.Sprite).spriteFrame = new cc.SpriteFrame(texture)
                }
            }.bind(this))

            // 动画效果
            if (i < 3) {
                node.getChildByName("node").runAction(cc.repeatForever(cc.sequence(cc.delayTime(i), cc.scaleTo(0.5, 1.2).easing(cc.easeSineOut()), cc.scaleTo(0.5, 1).easing(cc.easeSineOut()), cc.delayTime(2 - i))))
            }
        }
    }

    private checkLeftAndRightBtn () {
        this.nodeLeft.active = this.lyContent.node.x < 0
        this.nodeRight.active = this.lyContent.node.x + this.lyContent.node.width > this.lyContent.node.parent.width
    }
}
